// Single source of truth for plan definitions.
// Backend subscription limits are in EasyReports-Backend/src/templates/subscriptionPlans.js
// Stripe price IDs live only on the backend (stripeController.js / env vars).
// The frontend identifies plans by planKey and sends that key to the backend checkout endpoint.

export const PLANS = [
  {
    name: "Free",
    planKey: "free",
    price: "$0",
    period: "/yr",
    stripePlanKey: null,   // no checkout for free plan
    features: [
      "5 report cards / year",
      "10 AI generations / year",
      "All report card templates",
      "Class sharing",
    ],
    highlight: false,
  },
  {
    name: "Standard",
    planKey: "standard",
    price: "$10",
    period: "/yr",
    stripePlanKey: import.meta.env.VITE_STRIPE_PRICE_STANDARD,
    features: [
      "50 report cards / year",
      "100 AI generations / year",
      "All report card templates",
      "Class sharing",
    ],
    highlight: true,
  },
  {
    name: "Professional",
    planKey: "professional",
    price: "$20",
    period: "/yr",
    stripePlanKey: import.meta.env.VITE_STRIPE_PRICE_PROFESSIONAL,
    features: [
      "Unlimited report cards",
      "Unlimited AI generations",
      "All report card templates",
      "Class sharing",
      "Priority support",
    ],
    highlight: false,
  },
];
